export const loginUser = "post/loginuser";
export const signupuser = "post/signupuser";
export const updatedUser = "put/user"
export const logoutUser = "get/logout"